import { render } from "./ClearCacheBtn.vue?vue&type=template&id=2ffde4d6"
import script from "./ClearCacheBtn.vue?vue&type=script&lang=js"
export * from "./ClearCacheBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__